export default __webpack_public_path__ + "static/media/Fasthand-Regular.83ad7a92.ttf";